import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

//初始样式
import '@/assets/css/index.css'
//公共样式
import '@/assets/css/public.css'
//富文本载体元素所需css
import '@/assets/css/quill.snow.css'

//element ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)
//element ui

// 公共组件
import SelfTips from '@/components/SelfTips.vue'  //标题
Vue.component('SelfTips', SelfTips)
import BindButton from '@/components/BindButton.vue' //绑定户号按钮
Vue.component('BindButton', BindButton)
import SelfUpload from '@/components/SelfUpload.vue'  //图片上传
Vue.component('SelfUpload', SelfUpload)
import WaterArea from '@/components/select/WaterArea.vue' //用水区域select
Vue.component('WaterArea', WaterArea)
import WaterNo from '@/components/select/WaterNo.vue' //用水区域select
Vue.component('WaterNo', WaterNo)
import PublicAttached from '@/components/PublicAttached.vue' //附件下载
Vue.component('PublicAttached', PublicAttached)
// 公共组件

//正则
import { CheckNumber, CheckId, CheckEmail ,AddressReplace,NameReplace} from '@/utils/regular.js'
Vue.prototype.$CheckNumber = CheckNumber  //手机号
Vue.prototype.$CheckId = CheckId  //身份证号
Vue.prototype.$CheckEmail = CheckEmail  //邮箱
Vue.prototype.$AddressReplace = AddressReplace  //地址脱敏
Vue.prototype.$NameReplace = NameReplace  //姓名脱敏
//正则

//文件上传路径
import { path } from '@/utils/path.js'
Vue.prototype.$uploadUrl = `${path.dev}api/FileUpload`
Vue.prototype.$Path = path.dev
//文件上传路径

/* 其他 */
import { KeepTwoPoint, GetDate } from '@/utils/other.js'
//千分位
Vue.prototype.$KeepTwoPoint = KeepTwoPoint;
//获取当天日期
Vue.prototype.$GetDate = GetDate;
/* 其他 */

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
